export default __webpack_public_path__ + "static/media/information--minimum-speed-50--g1.76ed27c6.png";